import styled from "styled-components";

export const NavWrapper = styled.div`
  font-family: "Nunito";
  margin-bottom: 20px;
  .nav-link {
    cursor: pointer;
  }
  .active {
    background-color: #f8f8f8 !important;
    color: #293134 !important; // Grey2
    font-weight: 700;
    border-bottom: solid 1px #f8f8f8 !important;
  }
  .nav {
    margin-left: 2.5rem !important;
  }
`;
